module.exports = __webpack_public_path__ + "media/images/lms/canvas-7a529ffcd091663b969fbdca8d207df4.png";